<template>
    <div>
        <h1>Welcome to {{ settings.applicationname }}</h1>


        <label for="example-datepicker">Choose a start date:</label>
    <b-form-datepicker 
        id="startdate" 
        v-model="startdate" 
        class="mb-2"
        today-button
        reset-button
        close-button
    ></b-form-datepicker>

    <label for="example-datepicker">Choose a review date:</label>
    <b-form-datepicker id="reviewdate" v-model="reviewdate" class="mb-2"></b-form-datepicker>
    </div>
</template>

<script>
    import moment from 'moment';
    import { mapGetters } from 'vuex'

    export default {
        name: 'CreateAppraisal',
        data () {
            return {
                startdate: moment().format("YYYY-MM-DD"),
                reviewdate: moment().add(1, 'years').format("YYYY-MM-DD")   ,
            }
        },
        computed: {
            ...mapGetters(['settings', 'appraisals'])
        },
    }
</script>
